import styled, { css } from 'styled-components';
import {
  PANEL_HEADER_DENSITY_TOKENS,
  type PanelHeaderDensity,
} from './PanelHeader.constants';

interface RootProps {
  $density: PanelHeaderDensity;
  $sticky: boolean;
  $bordered: boolean;
}

export const Root = styled.header<RootProps>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  gap: 12px;
  ${({ $density }) => {
    const tokens = PANEL_HEADER_DENSITY_TOKENS[$density];
    return css`
      min-height: ${tokens.height};
      padding: 0 ${tokens.padX};
    `;
  }}

  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurface ?? '#E4E1ED'};
    background: ${colors.surfaceContainer ?? 'transparent'};
  `}

  ${({ $bordered, theme: { colors = {} } }) =>
    $bordered &&
    css`
      border-bottom: 1px solid ${colors.outlineVariant ?? '#464555'};
    `}

  ${({ $sticky }) =>
    $sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 1;
    `}
`;

export const Leading = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  gap: 2px;
`;

export const Title = styled.h2<{ $density: PanelHeaderDensity }>`
  margin: 0;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ $density }) => css`
    font-size: ${PANEL_HEADER_DENSITY_TOKENS[$density].titleFontSize};
  `}
  color: inherit;
`;

export const Subtitle = styled.p<{ $density: PanelHeaderDensity }>`
  margin: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ $density }) => css`
    font-size: ${PANEL_HEADER_DENSITY_TOKENS[$density].subtitleFontSize};
  `}
  ${({ theme: { colors = {} } }) => css`
    color: ${colors.onSurfaceVariant ?? '#C7C4D7'};
  `}
`;

export const Actions = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  margin-left: auto;
`;
